import * as invocator_services from './InvocatorServices'
//import { browserHistory } from 'react-router'

export const invocatorServices = invocator_services
//export const history = browserHistory
